import { render } from "./CreateDisclosure.vue?vue&type=template&id=57a57ead"
import script from "./CreateDisclosure.vue?vue&type=script&lang=js"
export * from "./CreateDisclosure.vue?vue&type=script&lang=js"
script.render = render

export default script